<template>
	<v-card flat max-width="950px" class="mx-auto transparent">
        <HeadRoot 
            title="Team Admin"
            :length="0"
            btn_txt=""
            btn_to="" />
        
        <div class="mt-2">
            <v-btn text @click="$router.go(-1)">
                <v-icon size="14px" color="grey darken-3" class="mr-3">fa-angle-left</v-icon>
                Back
            </v-btn>
        </div>

        <v-card flat class="transparent" v-if="loaded">
            <v-card-text>
                <div class="d-flex align-center">
                    <GroupAvatar :photo="item.photo" size="80px"/>
                    <div class="ml-3">
                        <div class="display-1 font-weight-light">{{item.name}}</div>
                        <div class="mt-n1 caption ml-1">{{item.str}}</div>
                        <div class="mt-n1 caption ml-1">{{item.group.reference}}</div>
                        <div class="mt-n1 caption ml-1">{{item.center.name}} Center</div>
                    </div>
                </div>
            </v-card-text>
        </v-card>

        <SendingLoader v-if="!loaded"/>

        <v-tabs v-model="tab" class="mt-2" background-color="grey lighten-5" v-if="loaded">
            <v-tab>Participants</v-tab>
            <v-tab>Presentations</v-tab>

            <v-tab-item>
                <Participants :teamId="item.id" />
            </v-tab-item>
            <v-tab-item>
                <Presentations :teamId="item.id" />
            </v-tab-item>
        </v-tabs>
        
	</v-card>
</template>

<script>
import Teams from '@/firebase/teams'
import Participants from '@/components/teams/Participants'
import Presentations from '@/components/teams/Presentations'

export default {
    data: () => ({
        loaded: false,
        item: null,
        schedule: null,
        tab: 0,
        ct: null
    }),
    components: {
        Participants,
        Presentations
    },
    mounted() {
        this.getParams();
        this.init();
    },
    methods: {
        getParams() {
            let url = new URL(window.location.href);
            this.ct = url.searchParams.get('ct');
        },
        init() {
            Teams.get(this.$route.params.id)
                    .then(response => {
                        if (response.status === true) {
                            this.item = response.doc.data();
                            this.item.id = response.doc.id;
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred, please try again later.'});
                        }
                    });
        }
    }
}
</script>